import { useEffect } from 'react';
import SubscriptionGuard from '@/v2/components/SubscriptionGuard/SubscriptionGuard';
import useGetSubscriptionQuery from '@/v2/domains/Subscriptions/queries/useGetSubscriptionQuery.hook';
import usePaymentFlowAnalytics from '@/v2/domains/Analytics/hooks/usePaymentFlowAnalytics.hook';
import {
  PaymentFlowStep,
  PaymentSection,
} from '@/v2/domains/Analytics/types/payment';

import TeacherProExpiredSubscriptionBanner from './components/TeacherProExpiredSubscriptionBanner/TeacherProExpiredSubscriptionBanner';
import TeacherExpiredSubscriptionBanner from './components/TeacherExpiredSubscriptionBanner/TeacherExpiredSubscriptionBanner';
import FamilyExpiredSubscriptionBanner from './components/FamilyExpiredSubscriptionBanner/FamilyExpiredSubscriptionBanner';
import OrganizationExpiredSubscriptionBanner from './components/OrganizationExpiredSubscriptionBanner/OrganizationExpiredSubscriptionBanner';

type ExpiredSubscriptionBannerProps = {
  title?: string;
  size?: 'large' | 'small';
};

export default function ExpiredSubscriptionBanner({
  title,
  size = 'large',
}: ExpiredSubscriptionBannerProps) {
  const { onStepViewed } = usePaymentFlowAnalytics({
    section: PaymentSection.paywall,
    step: PaymentFlowStep.paymentModalViewed,
  });

  const { data: subscription } = useGetSubscriptionQuery();

  useEffect(() => {
    onStepViewed();
  }, []);

  if (subscription?.organizationalLicense) {
    return (
      <OrganizationExpiredSubscriptionBanner
        organizationalLicense={subscription.organizationalLicense}
        title={title}
        size={size}
      />
    );
  }

  return (
    <SubscriptionGuard>
      <SubscriptionGuard.TeacherPro>
        <TeacherProExpiredSubscriptionBanner title={title} size={size} />
      </SubscriptionGuard.TeacherPro>
      <SubscriptionGuard.Teacher>
        <TeacherExpiredSubscriptionBanner title={title} size={size} />
      </SubscriptionGuard.Teacher>
      <SubscriptionGuard.Family>
        <FamilyExpiredSubscriptionBanner title={title} size={size} />
      </SubscriptionGuard.Family>
    </SubscriptionGuard>
  );
}
